// import { logEvent } from '@firebase/analytics';
// import { firebaseAnalytics } from '../firebase';
import getTimezone from '../timezone';
import { queueReportCustomError } from './reportQueue';
import type { EBiz } from './report_biz';
import type { ReportKeys } from './type';

// 通过 枚举 限定上报的 key，方便管理
export enum EReportCustomErrorKey {
  ogi = 'ogi', // ogi 解析失败上报，方便 小杰哥 进行针对性优化
  chat_load_error = 'chat_load_error' // chat 的监听异常上报
}

export default function reportErrorCustom(
  key: EReportCustomErrorKey,
  params?: ReportKeys,
  biz?: EBiz
): void {
  const searchParams = new URLSearchParams(window.location.search);
  const timezone = getTimezone();

  // 为了以防万一，默认使用 key10 填写 biz 的值，防止被占用
  const newParams: ReportKeys = {
    key10: biz,
    ...(timezone ? { timezone } : {}),
    ...(searchParams.get('utm_source')
      ? { utm_source: searchParams.get('utm_source') || undefined }
      : {}),
    ...(searchParams.get('utm_medium')
      ? { utm_medium: searchParams.get('utm_medium') || undefined }
      : {}),
    ...(searchParams.get('utm_campaign')
      ? { utm_campaign: searchParams.get('utm_campaign') || undefined }
      : {}),
    ...(params || {})
  };

  // logEvent(firebaseAnalytics(), key as string, newParams);
  queueReportCustomError(key, newParams);
}
